import { render, staticRenderFns } from "./ScoreLockPasswordSave.vue?vue&type=template&id=48fada52&"
import script from "./ScoreLockPasswordSave.vue?vue&type=script&lang=js&"
export * from "./ScoreLockPasswordSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports